"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getTableConversationRelation_1 = require("./getTableConversationRelation");
/**
 * Get all item ids in the conversations
 * @param conversationIds an array of conversation itemIds
 * @param tableViewId the table view id
 * @return an array of all item id strings in the specified conversations
 */
function getItemIdsFromConversations(rowKeys, tableViewId) {
    var allItemIds = {};
    rowKeys.forEach(function (rowKey) {
        var itemIds = getTableConversationRelation_1.default(rowKey, tableViewId).itemIds;
        itemIds.forEach(function (id) {
            // In case of multi-value sorts there can be two rows with same conversation
            // Hence we have to dedup the ids
            if (!allItemIds[id]) {
                allItemIds[id] = true;
            }
        });
    });
    return Object.keys(allItemIds);
}
exports.default = getItemIdsFromConversations;
//# sourceMappingURL=getItemIdsFromConversations.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/data/owa-mail-list-store/lib/utils/getItemIdsFromConversations.js
// module id = 3194
// module chunks = 62